import styled, { css } from 'styled-components';
import { ANIMATION_DURATION } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';
import { getSpacingToken, getToken, Icon, IconButton } from '@optimus-web/core';

const SearchInputIcon = styled(Icon)`
    align-self: center;
    cursor: pointer;
    color: inherit;
`;
export const SearchIcon = styled(SearchInputIcon).attrs({ value: IconName.Search })``;

export const SearchBarIconButton = styled(IconButton)`
    color: ${getToken('textStaticSecondary')};
`;

export const SearchBarContainer = styled.div<{ isMobile: boolean; focused: boolean }>`
    position: relative;
    display: grid;
    grid-template-rows: 1fr;
    margin-top: ${getSpacingToken('200')}px;
    margin-bottom: ${getSpacingToken('200')}px;
    transition: margin;
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    border: 1px solid transparent;

    &:hover {
        border: 1px solid ${getToken('borderStaticPrimary')};
        border-radius: ${getToken('borderRadius100')}px;
    }

    ${(props) =>
        !props.focused &&
        css`
            transition-delay: ${ANIMATION_DURATION.fast}ms;
        `}

    ${(props) =>
        props.focused &&
        css`
            margin-bottom: 0;
            border: none !important;
        `}

    ${(props) =>
        props.isMobile &&
        css`
            grid-template-columns: min-content auto;
            border: none !important;
        `}
`;

export const SearchInputContainer = styled.div<{ focused: boolean; isLoading: boolean }>`
    width: 100%;
    height: 100%;
    padding-left: ${getSpacingToken('100')}px;
    padding-right: ${getSpacingToken('100')}px;
    background: ${getToken('paletteBrandNight0')};
    color: ${getToken('textStaticTertiary')};
    font-weight: ${getToken('fontWeight400')};
    border-radius: ${getToken('borderRadius100')}px;

    display: grid;
    grid-template-columns: 16px auto min-content;
    grid-template-rows: 1fr;
    align-content: center;
    align-items: center;
    grid-column-gap: ${getSpacingToken('100')}px;

    transition: border-radius, background, grid-template-columns, padding-left, padding-right, color;
    transition-duration: ${ANIMATION_DURATION.fast}ms;

    ${(props) => !props.focused && `transition-delay: ${ANIMATION_DURATION.fast}ms;`}

    ${(props) =>
        props.focused &&
        css`
            grid-template-columns: 0 auto min-content;
            padding-left: ${getSpacingToken('50')}px;
            padding-right: ${getSpacingToken('100')}px;
            color: ${getToken('textStaticSecondary')};
            border-radius: ${getToken('borderRadius200')}px ${getToken('borderRadius200')}px 0 0;
        `}

    ${(props) =>
        props.isLoading &&
        css`
            grid-template-columns: 0 auto min-content;
        `}
`;

export const SearchIconContainer = styled.div<{ focused: boolean }>`
    display: grid;
    transition: opacity;
    transition-duration: ${ANIMATION_DURATION.fast}ms;

    ${(props) =>
        props.focused &&
        css`
            opacity: 0;
        `}
    ${(props) => !props.focused && `transition-delay: ${ANIMATION_DURATION.fast}ms;`}
`;

export const AutoCompleteContainer = styled.div<{ show: boolean }>`
    z-index: 1;
    position: absolute;
    top: 47px;
    background: ${getToken('paletteBrandNight0')};
    box-shadow: ${getToken('shadow100')};

    min-width: 336px;
    max-height: 500px;
    overflow-y: auto;
    margin-bottom: -7px;

    border-radius: ${getToken('borderRadius100')}px;

    ${(props) =>
        !props.show &&
        css`
            display: none;
        `}
`;
